// Корень приложения. AuthGate гейтит весь UI (включая роутер) — пока юзер не
// аутентифицирован, экран входа; после auth — RouterProvider монтирует Shell
// и текущий маршрут. Layout/keyboard/DnD живут в AppShell (router/app-layout
// pathless route → ./AppShell.tsx). Сами экраны — в ./router/routes/*.

import { Switch, Match } from 'solid-js'
import { RouterProvider } from '@tanstack/solid-router'
import { router } from './router/router'
import { useAuth, LOGIN_URL } from './auth.tsx'
import { Icon } from './Icons'

// Gate: пока auth не разрешился — показываем splash; если не залогинен —
// центрированный экран входа; если залогинен через Google, но админ ещё не
// залинковал юзера к внутреннему User (`linked: false` в MeResponse) —
// «awaiting approval» с возможностью разлогиниться и зайти под другим
// аккаунтом. Сами «приложенческие» данные сейчас моковые (data.ts), но без
// авторизации показывать их некорректно — это личное пространство юзера.
function AuthGate(props: { children: any }) {
  const { me, logout } = useAuth()
  return (
    <Switch>
      <Match when={me.loading}>
        <div class="auth-splash">Загрузка…</div>
      </Match>
      <Match when={me.error}>
        <div class="auth-splash" style={{ color: 'var(--status-err)' }}>
          Ошибка авторизации: {String(me.error)}
        </div>
      </Match>
      <Match when={me() === null}>
        <div class="auth-gate">
          <div class="auth-gate-card">
            <h1>Lost Circulation</h1>
            <p>Войдите, чтобы открыть рабочее пространство.</p>
            <a class="btn btn-primary" href={LOGIN_URL} style={{ 'text-decoration': 'none' }}>
              <Icon name="user" />
              Войти через Google
            </a>
          </div>
        </div>
      </Match>
      <Match when={me() && !me()!.linked}>
        <div class="auth-gate">
          <div class="auth-gate-card">
            <h1>Lost Circulation</h1>
            <p>
              Вы вошли как <b>{me()!.email}</b>.
            </p>
            <p>
              Аккаунт ожидает подтверждения администратора. Как только вас
              привяжут — рабочее пространство станет доступно.
            </p>
            <button class="btn" onClick={() => void logout()}>
              <Icon name="user" />
              Войти под другим аккаунтом
            </button>
          </div>
        </div>
      </Match>
      <Match when={me()}>
        {props.children}
      </Match>
    </Switch>
  )
}

function App() {
  return (
    <AuthGate>
      <RouterProvider router={router} />
    </AuthGate>
  )
}

export default App
